import { render, staticRenderFns } from "./pg-table-checkbox-pic.vue?vue&type=template&id=3dfbb6f2&scoped=true"
import script from "./pg-table-checkbox-pic.vue?vue&type=script&lang=js"
export * from "./pg-table-checkbox-pic.vue?vue&type=script&lang=js"
import style0 from "./pg-table-checkbox-pic.vue?vue&type=style&index=0&id=3dfbb6f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfbb6f2",
  null
  
)

export default component.exports